import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { TextInput } from "../../generic/text-input/TextInput";
import { TextLoca } from "../../generic/text/TextLoca";
export var FoundEditName = React.memo(function (_a) {
    var coop = _a.coop, coopName = _a.coopName, setCoopName = _a.setCoopName, onSubmit = _a.onSubmit;
    if (coop) {
        return (React.createElement("div", { className: IdStyles.TextBoldAccent + " w100" },
            React.createElement("span", null, coop.name)));
    }
    else {
        var namePlaceholder = utilLoca.get(IdLoca.enterCoopName_desc);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: IdStyles.TextBoldPrimary + " w100" },
                React.createElement(TextLoca, { id: IdLoca.enterCoopName_title })),
            React.createElement(TextInput, { style: IdStyles.CoopFoundNameInput, placeholder: namePlaceholder, onChange: setCoopName, value: coopName, onSubmit: onSubmit })));
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/found-edit/FoundEditName.tsx
// module id = 2585
// module chunks = 3